import { BotDefaultLocale, NlpModel } from '@feedyou/schema'

import { FeedbotThunk } from '../../types'
import { actions } from '../nlpAnalyzerSlice'
import { feedbotToast } from '../../../lib/feedbotToast'
import { fetchModelAnalysis } from '../../../features/nlp-analyzer'
import { botFlowSelector } from '../../flow/selectors/botFlowSelector'

export const fetchAnalysisForModel =
  (nlpModel: NlpModel, defaultBotLocale: BotDefaultLocale = 'cs'): FeedbotThunk =>
  async (dispatch, getState) => {
    const modelId = nlpModel.id

    const botId = botFlowSelector(getState())?.id

    dispatch(actions.request(modelId))

    try {
      if (!nlpModel || !botId) {
        throw new Error('Model not found!')
      }

      const data = await fetchModelAnalysis(nlpModel, botId, defaultBotLocale)

      dispatch(actions.success({ data }))

      toastNotifyModelAnalysisResult(nlpModel.id, data.analysisWarnings.length)
    } catch (err) {
      dispatch(actions.failure(modelId))

      feedbotToast.error({
        id: `nlp-analysis-${nlpModel?.id}`,
        title: 'NLP analysis error',
        content: ` NLP Model ${nlpModel?.id} analysis finished with an error.`
      })
    }
  }

function toastNotifyModelAnalysisResult(modelName: string, warningsCount: number) {
  if (!warningsCount) {
    feedbotToast.success({
      id: `nlp-analysis-${modelName}`,
      title: 'NLP analysis finished',
      content: `NLP Model ${modelName} was analysed and nothing suspicious was found, good job!`
    })

    return
  }

  feedbotToast.info({
    id: `nlp-analysis-${modelName}`,
    title: 'NLP analysis finished',
    content: `NLP Model ${modelName} can be improved, please check ${warningsCount} ${
      warningsCount > 1 ? 'warnings' : 'warning'
    }.`
  })
}
